module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-4.e8ff9e04.jpg";